import { useEffect, useRef } from 'react'
import { initMetaPixel } from '../utils/metaPixel'

/** Initializes the Meta Pixel once for the lifetime of the page. */
export function useMetaPixel(): void {
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    initMetaPixel()
  }, [])
}
